// extracted by mini-css-extract-plugin
export var content = "_p1-1";
export var fullScreen = "_p1-0";